import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=30d5b4fa&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=30d5b4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d5b4fa",
  null
  
)

export default component.exports